import { request } from "./http";
import { buildListQuery } from "./query";
export const listarProductos = (params) =>
  request(`productos?perfil=listado_grid&${buildListQuery(params)}`);
export const obtenerProducto = (id) =>
  request(
    `productos/${id}?perfil=all&with=empresas,marca,tipoProducto,preciosGrupos,prodContenidos,prodRelacionados`,
  );
export const crearProducto = (payload) =>
  request("productos", {
    method: "POST",
    body: JSON.stringify({ ...payload, catalog_form: "complete" }),
  });
export const actualizarProducto = (id, payload) =>
  request(`productos/${id}`, {
    method: "PUT",
    body: JSON.stringify({ ...payload, catalog_form: "complete" }),
  });
export const eliminarProducto = (id) =>
  request(`productos/${id}`, { method: "DELETE" });
